import React from 'react';
import type { AnchorProps } from '@reach/router';
import { GatsbyLinkProps, Link } from 'gatsby';
import * as classes from './Footer.module.scss';
import clsx from 'clsx';

export interface IFooterLinkProps extends Omit<AnchorProps, 'ref' | 'to'> {
    text: string;
    href: string;
}

export const FooterLink: React.FunctionComponent<IFooterLinkProps> = props => {
    const { href, text, ...linkProps } = props;
    const isAbsoluteLink = !href.startsWith('/');
    const LinkComponent = !isAbsoluteLink ? Link : 'a';
    const componentProps = {
        ...linkProps,
        [isAbsoluteLink ? 'href' : 'to']: href,
        rel: isAbsoluteLink ? 'noopener' : undefined,
    } as GatsbyLinkProps<unknown>;
    const className = clsx(classes.link, props.className);
    return (
        <LinkComponent
            {...componentProps}
            className={className}
        >
            {text}
        </LinkComponent>
    );
};
